import { ProductCompareProvider } from '@jbhi-fi/components/src/ProductCompare';
import React, { ReactNode } from 'react';

const compareProductGroupIds = window.Jbhifi.compareProductGroupIds?.split(',');

export const ShopifyProductCompareProvider = ({
  shouldHideCompare,
  children,
}: {
  shouldHideCompare?: boolean;
  children: ReactNode;
}) => {
  return (
    <ProductCompareProvider compareProductGroupIds={compareProductGroupIds} shouldHideCompare={shouldHideCompare}>
      {children}
    </ProductCompareProvider>
  );
};
